/**
 * Shared EmptyState component (design-system Phase 2).
 * Not yet imported by any existing page — safe to iterate on.
 *
 * Replaces the four different empty-state strings found in the audit
 * ("No results", "No entries match your filters.", "No data.",
 * "No data loaded yet.") with one component; wording stays page-specific
 * via the `message` prop rather than being hardcoded here.
 *
 * Props:
 *  - message (required)
 *  - description: optional secondary line
 *  - icon: optional node
 *  - action: optional node (e.g. a Button), stacks below text on narrow screens
 */
export default function EmptyState({ message, description, icon, action, className = '' }) {
  return (
    <div className={`ds-empty-state ${className}`.trim()}>
      {icon && (
        <div className="ds-empty-state-icon" aria-hidden="true">
          {icon}
        </div>
      )}
      <p className="ds-empty-state-message">{message}</p>
      {description && <p className="ds-empty-state-description">{description}</p>}
      {action && <div className="ds-empty-state-action">{action}</div>}
    </div>
  );
}
